import { createSelector } from 'reselect';
import { map, getOr, sortBy, pipe, pick, get } from 'lodash/fp';
import { t } from '../../../modules/infra/i18n';
import * as shopSelector from '../../auth/selectors';

const mapWithKeys = map.convert({ cap: false });

const makeDescription = item => item.address
  && [item.address.zip, item.address.state, item.address.street].filter(Boolean).join(' ');

export const getShopsForSwitcher = createSelector(
  shopSelector.getShops,
  pipe(
    mapWithKeys((item, index) => ({
      ...pick(['id', 'name', 'alias', 'photos'], item),
      type: 'shop',
      // add 999 to endforce non-brand shops to go after brand shops (if any)
      shopOrder: getOr(index + 999, 'shopOrder')(item),
      description: makeDescription(item),
      brandName: getOr('', 'brand.name')(item),
    })),
    sortBy(item => item.name.toUpperCase()),
  )
);

export const getBrandForSwitcher = createSelector(
  state => state.auth.user && state.auth.user.brand,
  brand => brand && {
    id: brand.id,
    brandName: brand.name,
    name: t('brand:shop_switcher.admin_view_name'),
    description: t('brand:shop_switcher.admin_view_description'),
    type: 'brand',
  },
);

export const getBarbersForSwitcher = createSelector(
  shopSelector.getBarberShops,
  map(item => ({
    ...pick(['name', 'alias', 'photos'], item),
    type: 'barber',
    id: item.barberId,
    brandName: getOr('', 'brand.name')(item),
    description: makeDescription(item),
  }))
);

export const getActiveName = state => shopSelector.activeShopName(state) || shopSelector.getActiveBrandName(state);
export const getActiveId = state => shopSelector.getActiveShopId(state) || shopSelector.getActiveBrandId(state);
export const getActiveBrandLogo = (state) => {
  const activeShop = shopSelector.getActiveShop(state);
  const brand = get('brand', activeShop) || shopSelector.getBrand(state);

  return get('extension.logoImage', brand);
};
